import type { SupabaseClient } from '@supabase/supabase-js'

/** Persists a journal comment row (same as Trade Detail → comments section). */
export async function insertTradeComment(
  client: SupabaseClient,
  input: {
    tradeId: string
    userId: string
    text: string
    mood?: string | null
  }
): Promise<void> {
  const text = input.text.trim()
  if (!text) {
    throw new Error('Comment text is required')
  }
  const { error } = await client.from('comments').insert({
    trade_id: input.tradeId,
    user_id: input.userId,
    text,
    mood: input.mood ?? null,
  })
  if (error) throw error
}
